import { useResponsive } from '@ui/style/useResponsive';
import { headerHeight, spaceAboveHeader, spaceBelowHeader } from '@ui/style/variables';
const useAddNewTaskStyles = (dialog = false, mt = false, height = false) => {
    const { isMobileIpadNavigation } = useResponsive();
    const headingHeight = 48;
    const spaceBelowHeading = 34;
    const pageEndPadding = 8;
    const statusHeight = 52.8;
    const buttonHeight = 52;
    const outerContainerPadding = 28;
    const gapPaddingFieldsAndButton = 24;
    const TabsHeight = height ? 60 : 0;
    const cardContainerHeightDesktop = `${spaceAboveHeader + headerHeight + spaceBelowHeader + headingHeight + gapPaddingFieldsAndButton + spaceBelowHeading + pageEndPadding + buttonHeight + outerContainerPadding + statusHeight + TabsHeight}px`;
    return {
        main: {
            position: 'relative',
            // bgcolor: (theme) => theme.palette.background.paper,
            // backdropFilter:'blur(10px)',
            display: 'flex',
            flexDirection: 'column',
            // padding: 2,
            // py:2,  isDrawer?: boolean;
            borderRadius: (theme) => theme.spacing(4),
            gap: 1.5,
            zIndex: 10,
            // overflow: 'hidden',
            mt: mt || dialog || isMobileIpadNavigation ? 0 : 0
        },
        // bgImage: {
        //   position: 'absolute',
        //   top: 0,
        //   left: 70,
        //   width: "100%",
        //   height: "100%",
        //   backgroundImage: `url(${TaskBackground})`,
        //   backgroundRepeat: 'no-repeat',
        //   backgroundSize: 'contain',
        // } as SxProps<Theme>,
        fieldsContainer: {
            display: 'flex',
            flexDirection: 'column',
            maxHeight: isMobileIpadNavigation ? '100%' : `calc(100dvh - ${cardContainerHeightDesktop})`,
            gap: 1.5,
            padding: 0,
            overflow: 'auto'
        },
        buttonText: {
            color: (theme) => theme.palette.primary.main
        }
    };
};
export default useAddNewTaskStyles;
